module.exports = __webpack_public_path__ + "img/baojie.1c7ff4a5.svg";